import { render, staticRenderFns } from "./palce.vue?vue&type=template&id=049fc598"
import script from "./palce.vue?vue&type=script&lang=js"
export * from "./palce.vue?vue&type=script&lang=js"
import style0 from "./palce.vue?vue&type=style&index=0&id=049fc598&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports